import { LangAvailableList } from '../../types';

export default [] as LangAvailableList;
